import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AddressDetailModel } from '../../Models/Models/Customer/AddressDetailModel';

declare var IS_RUNNING_IN_APP_POOL;

export class DocumentsSenderAddressClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(): Promise<AddressDetailModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Documents/DocumentsSenderAddress/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<AddressDetailModel, any>(url, data);
  }
}

